import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1c57ea90&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1c57ea90&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=1c57ea90&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c57ea90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c57ea90')) {
      api.createRecord('1c57ea90', component.options)
    } else {
      api.reload('1c57ea90', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1c57ea90&scoped=true", function () {
      api.rerender('1c57ea90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RequiredEmailNotice/index.vue"
export default component.exports